import { Component, EventEmitter, Input, NgZone, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { InputHelperService } from '../../input/input-helper';
import { Broadcaster } from '../../broadcaster';

@Component({
    selector: 'language-string-multiple-selection',
    templateUrl: './language-string-multiple-selection.html',
    viewProviders: [{
            provide: ControlContainer,
            useExisting: NgForm,
        }],
    standalone: false
})
export class LanguageStringMultipleSelectionComponent {
  @Input('title') title: string;
  @Input('parseObj')
  set onUpdateParseObj(parseObj: any) {
    this.parseObj = parseObj;
    this.onInputUpdate();
  }
  @Input('name')
  set onOnUpdateName(name: string) {
    this.name = name;
    this.onInputUpdate();
  }
  @Input('required') required: boolean;
  @Input('tags') tags: Array<any>;
  @Input('allowDuplicates') allowDuplicates: boolean = true;
  @Output('onSelection') onSelection: EventEmitter<any> = new EventEmitter();
  @Output('onChangeEditReasonRegimenSOP') onChangeEditReasonRegimenSOP: EventEmitter<any> = new EventEmitter();

  list: Array<any> = [];
  name: string;
  parseObj: any;
  static parameters: any = [InputHelperService, NgZone, Broadcaster];
  constructor(public inputHelper: InputHelperService, private zone: NgZone, private broadcaster: Broadcaster) {
  }

  ngOnInit(): void {
  }

  private onInputUpdate(): void {
    if (!this.name || !this.parseObj) return;
    this.list = this.inputHelper.getValue(this.parseObj, this.name);
    if (!this.list) {
      this.list = [];
      this.inputHelper.setValue(this.parseObj, this.name, this.list);
    }
  }

  private onResultUpdate(): void {
    const temp = this.list;
    this.list = [];
    setTimeout(() => this.zone.run(() => {
      this.list = temp;
      this.inputHelper.setValue(this.parseObj, this.name, this.list);
      this.onSelection.emit(this.list);
      this.onChangeEditReasonRegimenSOP.emit();
    }), 0);
  }

  addToRowLanguageString(item: any): void {
    // Check for duplicates if allowDuplicates is false
    if (!this.allowDuplicates && this.isDuplicate(item)) {
      this.showDuplicateWarning(item);
      return;
    }

    this.list.push(item);
    this.onResultUpdate();
  }

  removeToRowLanguagesStringValues(index: number): void {
    this.list.splice(index, 1);
    this.onResultUpdate();
  }

  private isDuplicate(newItem: any): boolean {
    return this.list.some((existingItem: any) => {
      return existingItem.id === newItem.id;
    });
  }

  private showDuplicateWarning(item: any): void {
    const itemName = item.get('en') || 'item';
    this.broadcaster.broadcast('NOTIFY', {
      message: `"${itemName}" is already selected. Duplicates are not allowed.`,
      type: 'warning'
    });
  }
}
